<template>
    <div class="goods-item" @click="handleDetail(data)">
        <img class="goods-img" v-lazy="$publicFn.optimizationImage(data.picUrl || data.pic, {size: {w:343,h:343}})">
        <div class="goods-info">
            <div class="goods-title van-ellipsis">{{data.name}}</div>
            <div class="goods-tags" v-if="data.categoryName">
                <div class="tags-item" v-for="(tag,index) in data.categoryName.split(',')" :key="index">{{tag}}</div>
            </div>
            <div class="goods-price">
                <div class="price-num">
                    <span class="unt">¥</span>{{data.salePrice}}
                    <div class="sales-num">已售{{formatNum(data.orderNumber)}}</div>    
                </div>
            </div>
            <div class="goods-institution">{{data.branchName}} <i class="icon-right" /></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'goodsItem',
    props: {
        data: {
            type: Object,
            default: ()=>{},
        },
    },
    methods: {
        formatNum(val) {
            if(val > 10000) {
                return `${parseFloat((val/10000).toFixed(1))}w+笔`
            }
            return `${val || 0}笔`
        },
        handleDetail({goodsId, id}, autoplay = 0) {
            this.$router.push({
                path: '/entityGoodsDetail',
                query: {
                    goodsId: goodsId || id,
                    goodsKinds: 3,
                    visit_referrer: 'couponGoodsList',
                    isH5: 1,
                    autoplay,
                }
            })
        },
        // async handleStationPage(branchId) {
        //     let url = await this.$publicFn.getSaasBranchDomain(branchId);
        //     if(this.$isapp){
        //         this.$WDJSBridge.useNewPage(
        //             JSON.stringify({
        //                 url: `${url}/stationPage`,
        //                 pageName: "stationPage",
        //             })
        //         );
        //     } else {
        //         window.location.href = `${url}/stationPage`
        //     }
        // }
    },
}
</script>

<style lang="less" scoped>
    .goods-item {
        background-color: #fff;
        border-radius: 16px;
        padding-bottom: 24px;
        width: 343px;
        box-sizing: border-box;
        .goods-img {
            width: 343px;
            height: 343px;
            border-radius: 16px 16px 0 0;
            margin-bottom: 16px;
            border: 1px solid #f1f1f1;
        }
        .goods-info {
            padding: 0 16px;
        }
        .goods-title {
            font-size: 30px;
            font-weight: 500;
            color: #333333;
            line-height: 38px;
            margin-bottom: 16px;
        }
        .goods-tags {
            display: flex;
            flex-wrap: wrap;
            height: 36px;
            overflow: hidden;
            margin-bottom: 24px;
            .tags-item {
                height: 36px;
                line-height: 36px;
                font-size: 20px;
                color: #999;
                padding: 0 12px;
                margin-right: 8px;
                max-width: 124px;
                background-color: #F2F2F7;
                border-radius: 4px;
            }
        }
        .goods-price {
            display: flex;
            margin-bottom: 16px;
            .price-num {
                font-size: 36px;
                color: #FF2F2F;
                font-weight: 600;
                .unt {
                    font-size: 20px;
                }
                .sales-num {
                    font-size: 20px;
                    color: #999;
                    display: inline-block;
                }
            }
        }
        .goods-institution {
            font-size: 24px;
            color: #999;
            line-height: 28px;
            display: flex;
            align-items: center;
            .icon-right {
                width: 16px;
                height: 16px;
                display: inline-block;
                background: url('../asset/images/icon_right.png') no-repeat center center /100% 100%;
            }
        }
    }
</style>